export default "__VITE_ASSET__Byqcu0Kl__"